module.exports = __webpack_public_path__ + "static/original-c4d7730c9217066157b70e583692052d.png";